
import { defineComponent, reactive, readonly, shallowReadonly } from 'vue';
export default defineComponent({
    name: 'App',
    setup() {
        const state = reactive({
            name: 'aaa',
            age: 18,
            a: {
                b: 'c'
            }
        });
        const state1 = readonly({});
        const state2 = shallowReadonly(state)
        const update = () => {
            // state.name += '=='
            // state1.name += '=='
            state2.a.b += '=='
            console.log(123);
        }
        return {
            state,
            state1,
            state2,
            update,
        }
    }
});
